// auth.js
import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import config from "./utils/config";


const oidcConfig = {
  authority: config.keycloak.discovery_url,
  client_id: config.keycloak.client_id,
  redirect_uri: window.location.origin + '/login',
  response_type: "code",
  // client_secret: config.keycloak.client_secret,
  scope: config.keycloak.scope,
  post_logout_redirect_uri: window.location.origin + '/login',
  loadUserInfo: true,
  useRefreshTokens: true,
  automaticSilentRenew: true,
};

const userManager = new UserManager({
  ...oidcConfig,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

userManager.events.addUserLoaded((user) => {
  console.log('[Auth] User loaded / token renewed. Expires at:', new Date(user.expires_at * 1000).toISOString(), '| Expires in (s):', Math.round(user.expires_at - Date.now() / 1000));
});

userManager.events.addAccessTokenExpired(() => {
  console.log("token expired...")
});

userManager.events.addSilentRenewError((error) => {
  console.log('[Auth] Silent renew error:', error);
});

userManager.events.addAccessTokenExpiring(() => {
  console.log("token expiring... (automaticSilentRenew will handle refresh)")
});


const methods = {
  login() {
    return userManager.signinRedirect();
  },
  
  logout(options) {
    return userManager.signoutRedirect(options);
  },

  getUser() {
    return userManager.getUser();
  },

  signinRedirectCallback() {
    return userManager.signinRedirectCallback();
  },
};

export default methods;
